var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2 Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 11.2 0 11.2 13.999989 0 13.999989"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Address-Book",
    transform: "translate(-821.000000, -187.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(821.613504, 187.573870)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    fill: "#E9E9E0"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    cx: 15.5,
    cy: 15.5,
    r: 15.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(9.809661, 8.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.309,12.6979844 C1.36064444,13.4326733 1.97244444,14.0018511 2.709,13.999989 L8.505,13.999989 C9.2414,14.0018511 9.85351111,13.4326733 9.905,12.6979844 L10.5,4.19998444 L0.7,4.19998444 L1.309,12.6979844 Z M11.2,1.74998444 L11.2,2.44998444 C11.2,2.64334 11.0432,2.79998444 10.85,2.79998444 L0.35,2.79998444 C0.156644444,2.79998444 0,2.64334 0,2.44998444 L0,1.74998444 C0,1.55662889 0.156644444,1.39998444 0.35,1.39998444 L3.5,1.39998444 L3.5,0.699984444 C3.5,0.313428889 3.81344444,-1.55555554e-05 4.2,-1.55555554e-05 L7,-1.55555554e-05 C7.38655556,-1.55555554e-05 7.7,0.313428889 7.7,0.699984444 L7.7,1.39998444 L10.85,1.39998444 C11.0432,1.39998444 11.2,1.55662889 11.2,1.74998444 L11.2,1.74998444 Z",
    id: "Fill-1",
    fill: "#A7A794",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIc);
export default __webpack_public_path__ + "static/media/delete-ic.ec75cf18a367fd8c00e667a944a92573.svg";
export { ForwardRef as ReactComponent };